<template>
    <div class="cnt">
        <Breadcrumb :current="2" />
        <h2 class="mb-[20px] sm:mb-[40px]">Scegli il tipo di veicolo</h2>

        <div class="flex flex-col sm:flex-row gap-[15px] sm:gap-[30px] sm:gap-0 items-center justify-around flex-wrap">
            <div v-if="mainStore?.abbonato?.sezioniVeicoli?.includes('Auto')" class="button p-[20px]" @click="selectVehicle('auto')">
                <font-awesome-icon icon="fa-solid fa-car-side" class="h-[50px]" />
            </div>
            <div v-if="mainStore?.abbonato?.sezioniVeicoli?.includes('Moto')" class="button p-[20px]" @click="selectVehicle('moto')">
                <font-awesome-icon icon="fa-solid fa-motorcycle" class="h-[50px]" />
            </div>
            <div v-if="mainStore?.abbonato?.sezioniVeicoli?.includes('VeicoloCommerciale')" class="button p-[20px]" @click="selectVehicle('vcom')">
                <font-awesome-icon icon="fa-solid fa-truck-moving" class="h-[50px]" />
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb.vue';
import { mainStore } from '../../store/main';

export default {
    name: 'SceltaVeicolo',
    components: { Breadcrumb },

    data() {
        return {
            mainStore,
        }
    },

    methods: {
        selectVehicle(type) {
            this.mainStore.type = type;
            this.$router.push("/ricerca-modello");
        },
    }
}
</script>

<style scoped>
.cnt {
    text-align: left;
    display: grid;
    width: 100%;
}
</style>